import { apiPost } from "../core/request";

/** ===== Profile: Phone ===== */
export async function apiProfileUpdatePhone(
  phone: string
): Promise<{ ok: boolean; status?: string }> {
  const res = await apiPost("/xapi/profile/phone", { phone });
  return res as { ok: boolean; status?: string };
}

/** ===== Profile: Banners (KYC / KYB / UBO) =====
 * Canonical path (new):  POST /xapi/profile/banners/:type/dismiss
 * Legacy fallback:       POST /xapi/profile/:type-banner/dismiss
 */
type BannerType = "kyc" | "kyb" | "ubo";

async function dismissBanner(type: BannerType): Promise<{ ok: boolean }> {
  // Try canonical first
  try {
    const r1 = await apiPost(`/xapi/profile/banners/${type}/dismiss`, {});
    return r1 as { ok: boolean };
  } catch (e: any) {
    // If it’s a 404 (older route set), attempt legacy path
    const status = e?.status ?? e?.response?.status;
    if (status === 404) {
      const legacy = await apiPost(`/xapi/profile/${type}-banner/dismiss`, {});
      return legacy as { ok: boolean };
    }
    throw e;
  }
}

export function apiDismissKycBanner(): Promise<{ ok: boolean }> {
  return dismissBanner("kyc");
}
export function apiDismissKybBanner(): Promise<{ ok: boolean }> {
  return dismissBanner("kyb");
}
export function apiDismissUboBanner(): Promise<{ ok: boolean }> {
  return dismissBanner("ubo");
}

/** ===== Profile: Email change request ===== */
export async function apiRequestEmailChange(
  email: string
): Promise<{ ok: boolean; message: string }> {
  const res = await apiPost("/xapi/profile/email/request-change", { email });
  return res as { ok: boolean; message: string };
}
